import React, { FC } from 'react';

import { TTextAlign } from '../../Text/models';
import { Text } from '../../Text';
import { TValueSize } from '@src/atoms/Value/models';
import { IComponentChildrenProps } from '@src/models/props';

interface IValueSimpleProps extends IComponentChildrenProps {
  size: TValueSize;
  textAlign: TTextAlign;
  nowrap?: boolean;
}

export const ValueSimple: FC<IValueSimpleProps> = ({ children, textAlign, nowrap, size }) => {
  return (
    <Text id={'valueSimple'} className={'ValueSimple_root'} size={size} align={textAlign} nowrap={nowrap}>
      {children}
    </Text>
  );
};
